/* istanbul ignore file */
import { connect } from 'react-redux';
import AppHeaderView from './AppHeaderView';
import { initAppHeader, showOutlookMenu, hideOutlookMenu } from '../actions/AppHeaderActions';

const mapStateToProps = (state, ownProps) => {
    const { headerData } = state.headerData;

    return {
        headerData,
        store: ownProps.store
    };
}

const mapDispatchToProps = dispatch => {
    return {
        initAppHeader: () => {
            dispatch( initAppHeader() )
        },
        showOutlookMenu: anchor => {
            dispatch( showOutlookMenu(anchor) )
        },
        hideOutlookMenu: () => {
            dispatch( hideOutlookMenu() )
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppHeaderView);